export default __webpack_public_path__ + "static/media/menu_mail_selected.4ad92056.svg";